import { useContext, useEffect, useMemo } from 'react';
import { matchPath, useLocation, useParams } from 'react-router-dom';

import routes, { ClassParams } from '../../pages/routes';
import { LayoutContext } from '../../shared/Layout/Context';
import { ClassTabItems } from './types';

export const ClassTabIds = {
  [ClassTabItems.ACTIVITIES]: 'class-activities-tab',
  [ClassTabItems.AGENDA]: 'class-agenda-tab',
  [ClassTabItems.ATTENDANCE]: 'class-attendance-tab',
};

export const ClassTabPanelIds = {
  [ClassTabItems.ACTIVITIES]: 'class-activities-tabpanel',
  [ClassTabItems.AGENDA]: 'class-agenda-tabpanel',
  [ClassTabItems.ATTENDANCE]: 'class-attendance-tabpanel',
};

export default function useClassHeaderVM() {
  const params = useParams<ClassParams>();
  const { pathname } = useLocation();

  const activeTab = useMemo(() => {
    const routeMap = {
      [routes.classActivities.path]: ClassTabItems.ACTIVITIES,
      [routes.classAgenda.path]: ClassTabItems.AGENDA,
      [routes.classAttendance.path]: ClassTabItems.ATTENDANCE,
    };

    for (const [path, tab] of Object.entries(routeMap)) {
      if (matchPath({ path, end: true }, pathname)) return tab;
    }

    return ClassTabItems.ACTIVITIES;
  }, [pathname]);

  /** Tabs */

  const { setSelectedTabIds } = useContext(LayoutContext);

  useEffect(
    function onActiveTabChange() {
      setSelectedTabIds({
        tabId: ClassTabIds[activeTab],
        panelId: ClassTabPanelIds[activeTab],
      });
    },
    [setSelectedTabIds, activeTab]
  );

  useEffect(
    function onMount() {
      return function cleanup() {
        setSelectedTabIds(null);
      };
    },
    [setSelectedTabIds]
  );

  return { activeTab, params };
}
